import React from "react";
import { useTranslation } from "react-i18next";

export default function NetworkLegend() {
  const { t } = useTranslation();
  
  return (
    <div className="network-legend">
      <div className="legend-title">{t('network.legend.title', 'Legend')}</div>
      
      <div className="legend-item">
        <div className="legend-dot" style={{ background: '#e91e8c' }} />
        <span className="legend-label">{t('network.legend.you', 'You')}</span>
      </div>
      
      <div className="legend-item">
        <div className="legend-dot" style={{ background: '#00bcd4' }} />
        <span className="legend-label">{t('network.legend.anonymousUser', 'Anonymous User')}</span>
      </div>
      
      <div className="legend-item">
        <div className="legend-dot" style={{ background: '#ff9800' }} />
        <span className="legend-label">{t('network.legend.corporation', 'Corporation')}</span>
      </div>
      
      <div className="legend-item">
        <div className="legend-line solid" />
        <span className="legend-label">{t('network.legend.dataMatch', 'Data Match')}</span>
      </div>
      
      <div className="legend-item">
        <div className="legend-line dashed" />
        <span className="legend-label">{t('network.legend.corporateRequest', 'Corporate Request')}</span>
      </div>
    </div>
  );
}
